export default __webpack_public_path__ + "static/media/elentra.7b015db8.jpg";